
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitomahabaleshwarcab() {



    const cardData =
    {
        keyword: 'Mumbai to Mahabaleshwar Cab Service',
        heading: 'Vedant Travels: Mumbai to Mahabaleshwar Cab Service',
        headingDescription: 'Vedant Travels provides dependable and affordable Mumbai to Mahabaleshwar Cab services, making your hill-station journey comfortable and stress-free. With transparent fares and no hidden costs, we offer multiple cab options including Sedan, SUV, and Innova Crysta to suit your travel preferences and budget. Whether you’re planning a family vacation, a weekend getaway, or a group trip, our professional drivers ensure safe rides, punctual pickups, and a smooth travel experience through the scenic Western Ghats. With 24x7 availability, clean and well-maintained vehicles, and easy online booking, Vedant Travels is your trusted choice for reliable Mumbai to Mahabaleshwar taxi services.',

        top: 'Top Places to Visit in Mahabaleshwar with Vedant Travels',

"topPlaces": [
    {
        "title": "Wilson Point (Sunrise Point)",
        "description": "Wilson Point is the highest point in Mahabaleshwar, offering a breathtaking 360-degree panoramic view of the surrounding hills and valleys. It is the best place to witness a mesmerizing sunrise, making it a must-visit attraction for nature lovers and photographers."
    },
    {
        "title": "Arthur’s Seat",
        "description": "One of the most popular viewpoints, Arthur’s Seat offers a stunning view of the Sahyadri Mountains and the Savitri River. This spot is known for its unique rock formations and floating stones, which resemble the ones found in Rameshwaram."
    },
    {
        "title": "Venna Lake",
        "description": "A trip to Mahabaleshwar is incomplete without visiting Venna Lake, a serene spot surrounded by lush greenery. Visitors can enjoy boating, horse riding, and street food stalls nearby, making it a perfect place for families and couples."
    },
    {
        "title": "Pratapgad Fort",
        "description": "Located about 24 km from Mahabaleshwar, Pratapgad Fort is a historic fort built by Chhatrapati Shivaji Maharaj. It is famous for the Battle of Pratapgad (1659) and offers spectacular views of the Konkan region. The fort is a great destination for history enthusiasts and trekking lovers."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "One of the most beautiful waterfalls in Maharashtra, Lingmala Waterfall offers a refreshing escape into nature. The best time to visit is during the monsoon season when the waterfall is in full flow, creating a breathtaking sight."
    },
    {
        "title": "Elephant’s Head Point",
        "description": "As the name suggests, Elephant’s Head Point resembles the shape of an elephant’s head and trunk. This viewpoint provides a stunning view of the Sahyadri ranges, deep valleys, and the Savitribai Phule Dam. It is an ideal place for a peaceful retreat away from the city rush."
    },
    {
        "title": "Mapro Garden",
        "description": "Famous for its strawberry farms and delicious fruit-based products, Mapro Garden is a must-visit place for food lovers. You can enjoy fresh strawberry cream, shakes, and sandwiches, along with shopping for homemade jams, syrups, and chocolates."
    },
    {
        "title": "Panchgani",
        "description": "Located just 20 km from Mahabaleshwar, Panchgani is a charming hill station known for its scenic views, strawberry farms, and colonial-era architecture. Popular attractions include Table Land, Sydney Point, and Parsi Point."
    },
    {
        "title": "Kate’s Point & Needle Hole Point",
        "description": "Kate’s Point offers a breathtaking view of Dhom Dam and Krishna Valley, while Needle Hole Point features a natural rock formation resembling a needle hole. These are perfect spots for photography and enjoying nature."
    },
    {
        "title": "Connaught Peak",
        "description": "The second-highest peak in Mahabaleshwar, Connaught Peak provides a panoramic view of the Krishna Valley, Venna Lake, and Pratapgad Fort. It is a great spot for trekking and adventure enthusiasts."
    }
],

"services": [
    {
        "name": "Mumbai to Mahabaleshwar Cab by Vedant Travels",
        "description": "Planning a trip to Mahabaleshwar from Mumbai? Book your cab with Vedant Travels for a comfortable and reliable journey. Our fleet of well-maintained vehicles and experienced drivers ensure a smooth and enjoyable ride to this beautiful hill station."
    },
    {
        "name": "Mumbai to Mahabaleshwar Taxi",
        "description": "For a stress-free journey from Mumbai to Mahabaleshwar, choose Vedant Travels. We offer professional taxi services that guarantee comfort and reliability. Whether you're traveling for leisure or a quick getaway, we provide the best taxis for your trip."
    },
    {
        "name": "Mumbai to Mahabaleshwar Car Hire",
        "description": "Looking for a car hire service from Mumbai to Mahabaleshwar? Vedant Travels offers flexible car hire options with a variety of vehicles, including sedans, SUVs, and more. Our rental services ensure you travel in comfort and convenience."
    },
    {
        "name": "Mahabaleshwar Taxi Service",
        "description": "Vedant Travels provides dependable taxi services to Mahabaleshwar from Mumbai. Our services are designed to make your journey comfortable, with experienced drivers who know the best routes and will ensure your trip is both safe and enjoyable."
    },
    {
        "name": "Mumbai to Mahabaleshwar Innova",
        "description": "For a premium and comfortable ride, book an Innova for your Mumbai to Mahabaleshwar journey. The Innova offers spacious seating and luxurious amenities, making it perfect for families or groups traveling to Mahabaleshwar."
    },
    {
        "name": "Mumbai to Mahabaleshwar One Way Taxi",
        "description": "Need a one-way taxi from Mumbai to Mahabaleshwar? Vedant Travels offers convenient one-way taxi services that provide flexibility and comfort for your journey. Enjoy a smooth ride with no hassle, and relax on your way to this scenic destination."
    },
    {
        "name": "Mumbai to Mahabaleshwar Cab Booking",
        "description": "Booking a cab for your Mumbai to Mahabaleshwar trip is simple with Vedant Travels. You can easily book online or over the phone, ensuring a hassle-free experience from start to finish. We offer flexible options to fit your schedule."
    },
    {
        "name": "Mahabaleshwar Trip from Mumbai",
        "description": "Whether you're looking for a weekend getaway or a quick trip to Mahabaleshwar, Vedant Travels has you covered. We offer reliable cab services, ensuring that your Mahabaleshwar trip from Mumbai is smooth, comfortable, and stress-free."
    },
    {
        "name": "Mumbai to Mahabaleshwar Taxi Fare",
        "description": "At Vedant Travels, we offer transparent and competitive pricing for your journey from Mumbai to Mahabaleshwar. Our taxi fares are affordable and fair, with no hidden charges. Contact us for an accurate fare estimate based on your specific travel details."
    }
],



"tableData": [
    ["Mumbai to Mahabaleshwar Cab", "Mumbai to Mahabaleshwar Taxi"],
    ["Mumbai to Mahabaleshwar Car Hire", "Mahabaleshwar Taxi Service"],
    ["Mumbai to Mahabaleshwar Innova", "Mumbai to Mahabaleshwar One Way Taxi"],
    ["Mumbai to Mahabaleshwar Cab Booking", "Mahabaleshwar Trip from Mumbai"],
    ["Mumbai to Mahabaleshwar Taxi Fare", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand how important it is to enjoy a stress-free trip to Mahabaleshwar. Our drivers ensure timely pickups and drop-offs, making your journey between Mumbai and Mahabaleshwar smooth and hassle-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "We offer well-maintained, spacious vehicles that are perfect for a long journey. Our cars are equipped with air conditioning, ample legroom, and comfortable seating to ensure a pleasant and relaxing trip to Mahabaleshwar."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are experienced and skilled in handling long-distance routes like Mumbai to Mahabaleshwar. They ensure a safe, smooth, and timely ride and are familiar with the best routes and road conditions."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels provides competitive pricing with no hidden charges. Our pricing is transparent, ensuring that you know exactly what you’re paying for, with no surprises during or after your journey."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. Our vehicles are regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure you have a worry-free journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you’re planning an early morning departure or a late-night return, Vedant Travels is available around the clock. Our customer service team is ready to assist you at any time of the day or night."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Mahabaleshwar cab is simple and convenient. You can book online through our website or mobile app, or contact our customer service team for assistance with the reservation."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "Whether you're traveling for leisure or on a family trip, we offer personalized travel packages for your Mumbai to Mahabaleshwar journey. Let us know your preferences, and we’ll tailor your trip to fit your comfort and schedule."
    }
  ]


    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Mahabaleshwar cab with Vedant Travels?',
            answer: 'You can easily book your cab online through our website or mobile app. Alternatively, our customer service team is available to assist you over the phone.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are experienced professionals trained in long-distance travel. They know the best routes to Mahabaleshwar and ensure you have a smooth and safe journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Mahabaleshwar travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are equipped for a comfortable and safe long-distance journey.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Mahabaleshwar cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip to Mahabaleshwar?',
            answer: 'Yes, we offer round-trip services for your journey. Simply provide your return details when booking, and we will ensure a smooth and comfortable return journey to Mumbai.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated clearly upfront. We ensure complete transparency in pricing with no hidden charges.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mahabaleshwar?',
            answer: 'Yes, we offer sightseeing services as part of your Mumbai to Mahabaleshwar trip. Explore local attractions such as Mahabaleshwar Temple, Venna Lake, and Elephant\'s Head Point with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Mahabaleshwar cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have larger or specialized luggage, please let us know at the time of booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Mahabaleshwar?',
            answer: 'Yes, we provide corporate travel services for business meetings, events, or team outings to Mahabaleshwar. We offer a comfortable and professional travel experience for corporate groups.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Mahabaleshwar travel?',
            answer: 'Vedant Travels offers reliable, affordable, and comfortable services for your journey to Mahabaleshwar. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure that your trip is safe, enjoyable, and stress-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Anil Kapoor",
            title: "Traveler",
            quote: "I traveled from Mumbai to Mahabaleshwar with Vedant Travels, and it was a fantastic experience. The vehicle was very comfortable, the driver was courteous, and we enjoyed a smooth, stress-free journey. Highly recommend!",
            rating: 5,
        },
        {
            name: "Mrs. Sushma Agarwal",
            title: "Family Traveler",
            quote: "We had a family trip from Mumbai to Mahabaleshwar, and Vedant Travels made it so easy. The car was spacious, the driver was friendly and professional, and we had a wonderful time exploring Mahabaleshwar. Definitely using their services again!",
            rating: 5,
        },
    ];
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
  const url = "https://www.vedanttravels.in/mumbai-to-mahabaleshwar-cab";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/mumbai-to-mahabaleshwar-cab-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block (helps rich results)
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Mahabaleshwar Cab | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/mumbai-to-mahabaleshwar-cab.jpg",
    "description": "Book Mumbai → Mahabaleshwar cabs — Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, professional chauffeurs, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 32711,          // within 8k–180k
      "reviewCount": 21406
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "3499",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Mumbai to Mahabaleshwar Cab",
        "description": "Mumbai → Mahabaleshwar taxi booking by Vedant Travels: Sedan/SUV/Innova, fixed fares, instant confirmation, scenic-stop options, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Mumbai to Mahabaleshwar Cab", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Mumbai", "Navi Mumbai", "Thane", "Mahabaleshwar", "Panchgani", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 158204      // within 8k–180k
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Mumbai to Mahabaleshwar Cab",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "One-way & round-trip taxi from Mumbai/Navi Mumbai/Thane to Mahabaleshwar — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, professional drivers.",
        "sku": "mumbai-mahabaleshwar-cab",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "3499",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 32711,      // within 8k–180k
            "reviewCount": 21406
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Hill Station Traveler" },
            "datePublished": "2025-07-19",
            "reviewBody": "Pickup from Bandra to Mahabaleshwar with a Mapro stop. Clean Innova and smooth ghat drive.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Family Trip" },
            "datePublished": "2025-05-07",
            "reviewBody": "Comfortable Sedan, polite chauffeur, and clear fare breakup. Recommended.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is the starting fare from Mumbai to Mahabaleshwar?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹3499. Final fare depends on car type, pickup time, route, and any sightseeing/waiting at Panchgani or viewpoints." }
          },
          {
            "@type": "Question",
            "name": "Do you offer stops at Lonavala or Panchgani?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes, optional scenic or food stops (e.g., Lonavala, Wai, Panchgani/Mapro) can be added. Waiting charges, if any, are shown upfront." }
          },
          {
            "@type": "Question",
            "name": "Are Expressway tolls and parking included?",
            "acceptedAnswer": { "@type": "Answer", "text": "Most fixed fares include Expressway tolls. Any hill-station parking/entry or extended waiting is shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Which cars are available?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta—AC, clean, GPS-enabled, with professional chauffeurs." }
          }
        ]
      }
    ]
  };



      


    return (
        <div>
           
 <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Mumbai to Mahabaleshwar Cab | One-Way & Round Trip Taxi | Vedant Travels</title>
        <meta
          name="description"
          content="Book Mumbai → Mahabaleshwar cabs at ₹3499 onwards. Sedan, SUV, Innova Crysta. Fixed fares, scenic-stop options, on-time pickup, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Mumbai to Mahabaleshwar Cab, Mumbai to Mahabaleshwar Taxi, One Way Cab Mumbai Mahabaleshwar, Innova Mumbai to Mahabaleshwar, Mumbai to Panchgani Cab"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Mumbai to Mahabaleshwar Cab | One-Way & Round Trip Taxi | Vedant Travels" />
        <meta property="og:description" content="Reliable Mumbai → Mahabaleshwar cabs—transparent fares, clean cars & pro drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mumbai to Mahabaleshwar Cab | One-Way & Round Trip Taxi" />
        <meta name="twitter:description" content="Mumbai → Mahabaleshwar cabs at ₹3499 onwards. Instant confirmation, 24×7 support." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>



            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitomahabaleshwarcab;